import { FormWithRedux } from '../../FormWithRedux';

export class GPChestPainNotesForm extends FormWithRedux {

    constructor() {
        super('notesForm');
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);
        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return 'string';
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return 'summary';
    }

}


// WEBPACK FOOTER //
// ./src/forms/gpChestPain01/Forms/GPChestPain-NotesForm.js